/** @file fetchBytes: the default bundle file reader (fetch + arrayBuffer, non-2xx throws BUNDLE_FETCH). */
import { throwError } from '@zilo/pose3d-std/errors/throwError';
import { RUNTIME_ERRORS } from '@zilo/pose3d-runtime-babylon/errors/runtimeErrors';

/** Reads one bundle file by URL; `loadPuppetBundle` takes any function of this shape (tests pass an in-memory one). */
export type FetchBytes = (url: string) => Promise<Uint8Array>;

/** `fetch(url)` as bytes; a non-2xx answer throws `BUNDLE_FETCH` with the URL and status at path `url`. */
export const fetchBytes: FetchBytes = async (url) => {
  const res = await fetch(url);
  if (!res.ok) return throwError(RUNTIME_ERRORS.BUNDLE_FETCH, { url, status: res.status }, { path: url });
  return new Uint8Array(await res.arrayBuffer());
};
